import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q21 = ({ history }) => {
  const { t } = useTranslation();
  const Q21Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question21')}
      options={Q21Options}
      nextUrl="q22"
      screenName="q21"
    />
  );
};

export default Q21;
